import turfObj from "@turf/bearing";

export default function bearing(point1, point2, options) {
    return turfObj(point1, point2, options);
};
